<template>
  <div class="container">
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
    />
    <div class="container-fluid h-custom">
      <div
        style="
          display: flex;
          justify-content: space-between;
          background-color: #f0f0f0;
          padding: 10px;
          border-radius: 5px;
        "
      >
        <h4 style="margin: 0; font-weight: bold; color: darkblue">
          Inicio de Sesión
        </h4>
      </div>
      <hr />
      <div>
        <div>
          <br />
          <h5>
            Recuerda cambiar tu contraseña regularmente y nunca la compartas con
            otros. Mantener tus contraseñas seguras es un paso importante para
            proteger tu privacidad y seguridad en línea.
          </h5>
          <br />
        </div>
      </div>
      <div class="d-flex" style="gap: 20px">
        <div class="flex-grow-1">
          <img
            src="../../assets/images/login.png"
            class="img-fluid border-rounded"
            alt="Sample image"
          />
        </div>
        <div
          class="flex-grow-1 border-rounded"
          style="background-color: beige; padding: 50px"
        >
        <br>
          <form id="login-form">
            <!-- Email input -->
            <div class="form-outline mb-4">
              <input
                type="text"
                id="usuario"
                class="form-control form-control-lg"
                placeholder="Nombre de usuario (ej: jperez)"
                v-model="usuario.usuario"
              />
            </div>

            <!-- Password input -->
            <div class="form-outline mb-4">
              <div class="input-group">
                <input
                  :type="passwordVisible ? 'text' : 'password'"
                  id="clave"
                  class="form-control form-control-lg"
                  placeholder="Ingresa tu contraseña"
                  v-model="usuario.clave"
                  @input="checkPasswordStrength"
                  autocomplete="off"
                />
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="togglePasswordVisibility"
                >
                  <span class="material-symbols-outlined">
                    {{ passwordVisible ? "visibility" : "visibility_off" }}
                  </span>
                </button>
              </div>
            </div>
        <br>
            <div class="d-flex justify-content-between align-items-center">
              <!-- Checkbox Recuérdame -->
              <div class="form-check">
                <input
                  type="checkbox"
                  id="rememberMe"
                  v-model="rememberMe"
                  class="form-check-input"
                />
                <label for="rememberMe" class="form-check-label"
                  >Recuérdame</label
                >
              </div>
              <router-link to="/OlvidoClave" class="link-danger"
                >¿Olvidó su contraseña?</router-link
              >
            </div>
        <br>
            <div class="d-flex justify-content-center mt-4 pt-2">
              <button
                type="button"
                class="btn btn-primary btn-lg"
                style="padding-left: 2.5rem; padding-right: 2.5rem"
                @click="login()"
              >
                Iniciar sesión
              </button>
            </div>
            <br />
            <br />
            <p class="mensaje">{{ mensaje }}</p>
            <p class="mensaje">{{ mensaje02 }}</p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import swal from "sweetalert2";

export default {
  data() {
    return {
      usuario: {},
      sesion: {},
      mensaje: "",
      mensaje02: "",
      passwordVisible: false,
      rememberMe: false,
      verReportes: 0,
    };
  },
  mounted() {
    const form = document.getElementById("login-form");
    form.addEventListener("keydown", this.handleEnterSubmit);
    this.checkRememberMe();
  },
  beforeUnmount() {
    const form = document.getElementById("login-form");
    form.removeEventListener("keydown", this.handleEnterSubmit);
  },
  methods: {
    handleEnterSubmit(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        this.login();
      }
    },
async login() {
  if (!this.usuario.usuario) {
    this.mensaje = "Ingrese el usuario/correo electrónico.";
    return;
  }
  if (!this.usuario.clave) {
    this.mensaje = "Ingrese la contraseña.";
    return;
  }

  try {
    const resp = await api.post("/login", this.usuario);
    const token = resp.data.result.token;
    // Guardar el token y otros datos en sessionStorage
    window.sessionStorage.setItem("token", token);
    window.sessionStorage.setItem("idUsuario", resp.data.result.idUsuario);
    window.sessionStorage.setItem("idPersona", resp.data.result.idPersona);
    window.sessionStorage.setItem("idMedico", resp.data.result.idMedico);
    window.sessionStorage.setItem("idPerfil", resp.data.result.idPerfil);
    window.sessionStorage.setItem("idSuscripcion", resp.data.result.idSuscripcion);
    window.sessionStorage.setItem("idPlan", resp.data.result.idPlan);
    window.sessionStorage.setItem("idPrestador", resp.data.result.idPrestador);
    window.sessionStorage.setItem("suscriptor", resp.data.result.suscriptor);
    window.sessionStorage.setItem("rol", resp.data.result.rol);
    window.sessionStorage.setItem("usuario", resp.data.result.nombre);
    window.sessionStorage.setItem("idEmpresa", resp.data.result.idEmpresa);
    window.sessionStorage.setItem("nombreEmpresa", resp.data.result.nombreEmpresa);
    window.sessionStorage.setItem("nombrePersona", resp.data.result.nombrePersona);

    // Solicitud GET sin encabezado manual, ya que el interceptor lo agrega
    const tiempoDisponible = await api.get(`/suscripcions/${resp.data.result.idSuscripcion}/tiempo-restante`);

    // Manejar la respuesta de tiempoDisponible
    if (
      tiempoDisponible &&
      tiempoDisponible.data &&
      tiempoDisponible.data.dias === 0 &&
      tiempoDisponible.data.horas === 0 &&
      tiempoDisponible.data.minutos === 0 &&
      tiempoDisponible.data.segundos === 0
    ) {
      swal.fire({
        title: "Suscripción Finalizada",
        text: "Tu tiempo de suscripción ha finalizado. Por favor, renueva tu plan para continuar disfrutando de nuestros servicios.",
        icon: "error",
        confirmButtonText: "Renovar Ahora",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          this.$router.push("/Renovacion01PLan");
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire(
            "Información",
            "Si necesitas ayuda o más información, por favor contacta con nuestro equipo de soporte.",
            "info"
          );
        }
      });
      return;
    }

    // Guardar módulos y opciones
    window.sessionStorage.setItem("moduloAdministracion", resp.data.result.moduloAdministracion);
    window.sessionStorage.setItem("moduloAtencion", resp.data.result.moduloAtencion);
    window.sessionStorage.setItem("moduloAuditoria", resp.data.result.moduloAuditoria);
    window.sessionStorage.setItem("moduloFacturacion", resp.data.result.moduloFacturacion);
    window.sessionStorage.setItem("moduloDashboards", resp.data.result.moduloDashboards);
    window.sessionStorage.setItem("menuParametros", resp.data.result.menuParametros);
    window.sessionStorage.setItem("menuProcesos", resp.data.result.menuProcesos);
    window.sessionStorage.setItem("menuReportes", resp.data.result.menuReportes);
    window.sessionStorage.setItem("menuAyuda", resp.data.result.menuAyuda);
    window.sessionStorage.setItem("opcionConsulta", resp.data.result.opcionConsulta);
    window.sessionStorage.setItem("opcionOperaciones", resp.data.result.opcionOperaciones);
    window.sessionStorage.setItem("opcionDescarga", resp.data.result.opcionDescarga);
    window.sessionStorage.setItem("opcionMenu", resp.data.result.opcionMenu);
    window.sessionStorage.setItem("reporteObsResp", resp.data.result.reporteObsResp);
    window.sessionStorage.setItem("reporteObsReex", resp.data.result.reporteObsReex);
    window.sessionStorage.setItem("reporteCarga", resp.data.result.reporteCarga);
    window.sessionStorage.setItem("reporteResumen", resp.data.result.reporteResumen);

    this.verReportes = Number(window.sessionStorage.getItem("reporteObsResp")) +
                       Number(window.sessionStorage.getItem("reporteObsReex")) +
                       Number(window.sessionStorage.getItem("reporteCarga")) +
                       Number(window.sessionStorage.getItem("reporteResumen"));

    window.sessionStorage.setItem("verReportes", this.verReportes);

    // Guardar sesión
    this.sesion.idUsuario = window.sessionStorage.getItem("idUsuario");
    this.sesion.fechaReg = new Date();
    this.sesion.direccionIp = "";
    this.sesion.userAgent = navigator.userAgent;
    try {
      await api.post("/sesions", this.sesion);
    } catch (error) {
      console.error("Error al guardar la sesión:", error);
      this.mensaje = "Error al guardar la sesión: " + (error.response?.data?.message || error.message);
    }

    // Obtener nombre completo
    try {
      const response = await api.get(`/vwpersonas/${window.sessionStorage.getItem("idPersona")}`);
      window.sessionStorage.setItem("nombreCompleto", response.data.nombreCompleto);
    } catch (error) {
      console.error("Error al obtener los datos de la persona:", error);
      this.mensaje = "Error al obtener los datos de la persona: " + (error.response?.data?.message || error.message);
    }

    if (this.rememberMe) {
      this.setRememberMe();
    }
    this.$router.push("/MenuPrincipal").then(() => {
      window.location.reload();
    });
  } catch (error) {
    // Manejo de errores
    if (error.response) {
      console.error("Error de respuesta del servidor:", error.response.data);
      if (error.response.status === 401 && error.response.data.message === "Contraseña expirada") {
        swal.fire({
          title: "Contraseña expirada",
          text: "Tu contraseña ha expirado. Por favor, cambia tu contraseña para continuar.",
          icon: "warning",
          confirmButtonText: "Cambiar Contraseña",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.value) {
            this.$router.push(`/login-actualizar-clave/${error.response.data.idUsuario}`);
          }
        });
      } else if (error.response.status === 401 && error.response.data.message === "Primer acceso") {
        swal.fire({
          title: "Primer acceso al sistema",
          text: "Bienvenido a su primer acceso al sistema. Por favor, cambie su contraseña para continuar.",
          icon: "warning",
          confirmButtonText: "Cambiar Contraseña",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.value) {
            this.$router.push(`/login-actualizar-clave/${error.response.data.idUsuario}`);
          }
        });
      } else {
        swal.fire("Error", error.response.data.message || "Error al iniciar sesión", "error");
      }
    } else {
      console.error("Error:", error.message);
      this.mensaje = "Error al conectar con el servidor. Por favor, intenta de nuevo.";
    }
  }
},
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    setRememberMe() {
      const loginInfo = {
        username: this.usuario.usuario,
        password: this.usuario.clave,
      };
      localStorage.setItem("rememberMe", JSON.stringify(loginInfo));
    },
    checkRememberMe() {
      const rememberedData = localStorage.getItem("rememberMe");
      if (rememberedData) {
        const loginInfo = JSON.parse(rememberedData);
        this.usuario.usuario = loginInfo.username;
        this.usuario.clave = loginInfo.password;
        this.rememberMe = true; // Establecer el checkbox a marcado
      }
    },
  },
};
</script>
<style scoped>
.divider:after,
.divider:before {
  content: "";
  flex: 1;
  height: 1px;
  background: #eee;
}

.h-custom {
  height: calc(100% - 73px);
}

@media (max-width: 450px) {
  .h-custom {
    height: 100%;
  }
}
.border-rounded {
  border-radius: 20px;
}
::placeholder {
  color: #C0C0C0; /* gris Bootstrap */
  opacity: 1;     /* para que no sea transparente */
}
.mensaje {
  color: red;
  font-weight: bold;
  text-align: center;
}
</style>
